import { render, staticRenderFns } from "./bulkShelves.vue?vue&type=template&id=565be04b&scoped=true"
import script from "./bulkShelves.vue?vue&type=script&lang=js"
export * from "./bulkShelves.vue?vue&type=script&lang=js"
import style0 from "./bulkShelves.vue?vue&type=style&index=0&id=565be04b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565be04b",
  null
  
)

export default component.exports